import { render, staticRenderFns } from "./DistributionFormComponent.vue?vue&type=template&id=099b3464"
import script from "./DistributionFormComponent.vue?vue&type=script&lang=js"
export * from "./DistributionFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports